<template>
    <div id="chartContextMenu" :show-menu="showMenu" class="print:hidden">
        <ul class="chartContextMenu__menu-list">
            <li @click="callChartAction('cmIndicators')">Add Indicator</li>
            <hr />
            <li @click="callChartAction('cmDrawingTool')">Add Drawing Tool</li>
            <li @click="callChartAction('cmSymbolTool')">Add Symbols</li>
            <li @click="callChartAction('cmCalculatorTool')">Add Calculator</li>
            <hr />
            <li @click="callChartAction('cmComparisonChart')">Comparison Chart</li>
            <hr />
            <li @click="callChartAction('cmDisplaySettings')">Display Options</li>
            <li @click="callChartAction('cmDisplayScale')">Scale Settings</li>
            <hr />
            <li @click="callChartAction('cmTemplate')">Templates</li>
            <hr />
            <li @click="callChartAction('handleOpenInNewWindow')" v-if="!chartSettings.fullScreen">Full Screen Chart</li>
            <li @click="callChartAction('print')">Print Chart Only</li>
            <li @click="callChartAction('printWithInfo')">Print Chart, Notes and 1Yr Values</li>
            <!-- <li @click="callChartAction('exportData')">Download Raw Data</li> -->
            <li @click="callChartAction('saveAsImage')">Save Chart as Image (.png)</li>
            <!-- <li @click="callChartAction('cmAddToChartBook')">Add to Chart Book</li> -->
            <li @click="callChartAction('cmReset')">Reset Chart</li>
            <hr />
            <li @click="callChartAction('cmSocialShare')">Share Chart</li>
            <hr />
        </ul>
    </div>
</template>

<script setup>
import { ref, computed } from 'vue';

const props = defineProps({
    settings: Object
});

const emit = defineEmits(['action']);

const chartSettings = ref(props.settings);
const viewMenu = ref(false);
// const isEquity = ref(true);
// const isEquityEtfMutual = ref(true);
// const isFutureSymbol = ref(true);

const showMenu = computed(() => {
    if (chartSettings.value.display) {
        openMenu();
        return true;
    } else {
        closeMenu();
        return false;
    }
});

const openMenu = () => {
    viewMenu.value = true;
    const contextMenu = document.getElementById('chartContextMenu');
    contextMenu.style.display = 'block';
    contextMenu.style.left = chartSettings.value.position.x + 'px';
    contextMenu.style.top = chartSettings.value.position.y + 'px';
};

const closeMenu = () => {
    if (viewMenu.value) {
        viewMenu.value = false;
        const contextMenu = document.getElementById('chartContextMenu');
        contextMenu.style.display = 'none';
    }
};

const navigate = () => {
    const route = window.route('my-folder.chart-templates.index');
    window.location = route;
};

// actions
const callChartAction = (action) => {
    emit('action', action);
};
</script>

<style lang="scss">
#chartContextMenu {
    @apply hidden absolute z-10 shadow;
    min-width: 240px;

    .chartContextMenu__menu-list {
        @apply list-none bg-white border m-0 p-0;

        & > li {
            @apply relative text-xs;
            @apply py-1 px-3;

            &.disabled {
                @apply text-gray-500;
                pointer-events: none;
            }

            a {
                @apply text-black;
            }

            &:hover {
                @apply cursor-pointer text-yellow-500 bg-gray-super-100;

                .sub-menu-content {
                    display: block;
                }
            }

            & > div {
                position: relative;
            }

            .sub-menu:after {
                @apply absolute;
                border: 6px #000 solid;
                border-top-color: transparent;
                border-bottom-color: transparent;
                border-right-color: transparent;
                right: 0;
                top: 5px;
                content: '';
            }

            .sub-menu-content {
                @apply hidden absolute shadow;
                min-width: 220px;
                left: 239px;
                top: 0;

                .chartContextMenu__sub-menu-list {
                    @apply list-none border m-0 p-0 bg-white text-black;

                    & > li {
                        @apply py-1 px-3 text-xs;

                        &:hover {
                            @apply cursor-pointer text-yellow-500 bg-smoke-100;
                        }
                    }
                }
            }
        }
        hr {
            @apply m-0 h-px bg-gray-400;
        }

        label {
            @apply font-normal;
        }
    }
}
</style>
